<template>
  <div style="height: inherit">
    <conciliacao-faturamento-itens-header />
    <conciliacao-faturamento-itens-status-bar class="mb-2" />
    <v-progress-linear v-if="loading" indeterminate />
    <div v-else style="overflow-y: auto; height: calc(100% - 96px - 8px)">
      <template v-if="countItens === 0">
        <v-container class="text-center">
          <div v-if="selectedFaturamentoItensFilterOption === 'todos'">Nenhum item encontrado</div>
          <div v-else-if="selectedFaturamentoItensFilterOption === 'conciliados'">Nenhum item conciliado</div>
          <div v-else-if="selectedFaturamentoItensFilterOption === 'nao-conciliados'">Todos os itens estão conciliados</div>
        </v-container>
      </template>
      <template v-else-if="countItens > 0">
        <conciliacao-faturamento-item-card
          v-for="item in itens"
          :key="item.id"
          :faturamento-item="item"
          :isUsuarioTradimus="isUsuarioTradimus"
          @click:card="handleCardClick"
          class="mb-2"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ConciliacaoFaturamentoItemCard from './ConciliacaoFaturamentoItemCard.vue'
import ConciliacaoFaturamentoItensHeader from './ConciliacaoFaturamentoItensHeader.vue'
import ConciliacaoFaturamentoItensStatusBar from './ConciliacaoFaturamentoItensStatusBar.vue'
import { sessionStorageClient } from '../../../libs'

export default {
  components: {
    ConciliacaoFaturamentoItemCard,
    ConciliacaoFaturamentoItensHeader,
    ConciliacaoFaturamentoItensStatusBar
  },
  data () {
    return {
      clickedItem: undefined,
      page: 1
    }
  },
  computed: {
    ...mapState('conciliacao', ['faturamentoItens', 'selectedFaturamentoItensFilterOption']),
    itens () {
      return this.faturamentoItens.result?.data
    },
    loading () {
      return this.faturamentoItens.loading
    },
    countItens () {
      return this.itens?.length
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    }
  },
  methods: {
    handleCardClick (faturamentoItem, currentChecked) {
      if (currentChecked) {
        this.$store.dispatch('conciliacao/deselectFaturamentoItem', faturamentoItem)
      } else {
        this.$store.dispatch('conciliacao/selectFaturamentoItem', faturamentoItem)
      }
    },
  }
}
</script>
